import { createAction } from "redux-actions";

export const CREATE_JOB = "CREATE_JOB";
export const createJob = createAction(CREATE_JOB);

export const CREATE_JOB_FAILURE = "CREATE_JOB_FAILURE";
export const createJobFailure = createAction(CREATE_JOB_FAILURE);

export const CREATE_JOB_REQUESTED = "CREATE_JOB_REQUESTED";
export const createJobRequested = createAction(CREATE_JOB_REQUESTED);

export const CREATE_JOB_SUCCESS = "CREATE_JOB_SUCCESS";
export const createJobSuccess = createAction(CREATE_JOB_SUCCESS);

export const UPDATE_JOB = "UPDATE_JOB";
export const updateJob = createAction(UPDATE_JOB);

export const UPDATE_JOB_FAILURE = "UPDATE_JOB_FAILURE";
export const updateJobFailure = createAction(UPDATE_JOB_FAILURE);

export const UPDATE_JOB_REQUESTED = "UPDATE_JOB_REQUESTED";
export const updateJobRequested = createAction(UPDATE_JOB_REQUESTED);

export const UPDATE_JOB_SUCCESS = "UPDATE_JOB_SUCCESS";
export const updateJobSuccess = createAction(UPDATE_JOB_SUCCESS);

export const FETCH_JOBS = "FETCH_JOBS";
export const fetchJobs = createAction(FETCH_JOBS);

export const FETCH_JOBS_FAILURE = "FETCH_JOBS_FAILURE";
export const fetchJobsFailure = createAction(FETCH_JOBS_FAILURE);

export const FETCH_JOBS_REQUESTED = "FETCH_JOBS_REQUESTED";
export const fetchJobsRequested = createAction(FETCH_JOBS_REQUESTED);

export const FETCH_JOBS_SUCCESS = "FETCH_JOBS_SUCCESS";
export const fetchJobsSuccess = createAction(FETCH_JOBS_SUCCESS);

export const FETCH_JOB_BY_ID = "FETCH_JOB_BY_ID";
export const fetchJobById = createAction(FETCH_JOB_BY_ID);

export const FETCH_JOB_BY_ID_FAILURE = "FETCH_JOB_BY_ID_FAILURE";
export const fetchJobByIdFailure = createAction(FETCH_JOB_BY_ID_FAILURE);

export const FETCH_JOB_BY_ID_REQUESTED = "FETCH_JOB_BY_ID_REQUESTED";
export const fetchJobByIdRequested = createAction(FETCH_JOB_BY_ID_REQUESTED);

export const FETCH_JOB_BY_ID_SUCCESS = "FETCH_JOB_BY_ID_SUCCESS";
export const fetchJobByIdSuccess = createAction(FETCH_JOB_BY_ID_SUCCESS);

export const UPDATE_JOB_WITH_STATUS = "UPDATE_JOB_WITH_STATUS";
export const updateJobWithStatus = createAction(UPDATE_JOB_WITH_STATUS);

export const UPDATE_JOB_DELIVERY_DATE = "UPDATE_JOB_DELIVERY_DATE";
export const updateJobDeliveryDate = createAction(UPDATE_JOB_DELIVERY_DATE);
